import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Col, Form, InputGroup, Offcanvas, Row } from "react-bootstrap";
import "./Edit_Profile_OffCanvas.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMale } from "@fortawesome/free-solid-svg-icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import RedRoundBtn from "../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";
import You_Are_Almost_There_Modal from "../Common_Component/Common_Modal/You_Are_Almost_There_Modal/You_Are_Almost_There_Modal";
import TermInsuranceStepform from "../Common_Component/Common_Modal/TermInsuranceStepform/TermInsuranceStepform";
import { LoanForm, LoanFormUpdate } from "../../utils/apis/form/form";
import Cookies from "js-cookie";
const Edit_Profile_OffCanvas = ({ setData, data, ...props }) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [showModal, setShowModal] = useState(false);
  const [active, setActive] = useState();

  const [activeOccupation, setActiveOccupation] = useState();

  const dateInputRef = useRef(null);

  console.log(showModal, "showModal showModal");

  const onSubmit = async (data) => {
    console.log(data, "data data data");

    const formData = new FormData();
    formData.append("id", data?.id);
    formData.append("dob", data?.dob);
    formData.append("service", data?.service);
    formData.append("type", data?.type);
    formData.append("name", data?.name);
    formData.append("gender", data?.gender);
    formData.append("contact_no", data?.contact_no);
    formData.append("occupation", activeOccupation);
    formData.append("qualification", data?.qualification?.value);
    formData.append("income", data?.income);
    formData.append("smoke_status", active);
    formData.append("city", data?.city);
    formData.append("pincode", data?.pincode);

    const res = await LoanFormUpdate(formData, data.id);
    if (res?.success) {
      await Cookies.set("user_data", JSON.stringify(res?.data), { expires: 7 });
      const d = await Cookies.get("user_data");
      await setData(d);

      props?.onHide();
      setShowModal(true);
    } else {
    }
  };

  useEffect(() => {
    if (data) {
      reset({
        ...data, // Spread existing data
        qualification:
          option.find((item) => item.value === data.qualification) || null,
      });
      setActive(data.smoke_status);
      setActiveOccupation(data.occupation);
    }
  }, [data, reset]);

  const option = [
    { value: "Below 10th", label: "Below 10th" }, // ✅ Fixed "lable" to "label"
    { value: "10th Pass", label: "10th Pass" },
    { value: "12th Pass", label: "12th Pass" },
    { value: "Graduate & Above", label: "Graduate & Above" },
  ];

  const getAge = (dob) => {
    if (!dob) return "Invalid Date"; // Handle empty or undefined DOB

    const birthDate = new Date(dob);
    const today = new Date();

    if (isNaN(birthDate.getTime())) return "Invalid Date"; // Handle invalid date formats

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    // Adjust age if birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age >= 0 ? `${age} yrs` : "Invalid Age"; // Prevent negative age
  };

  return (
    <section className="">
      <Offcanvas
        show={props?.show}
        onHide={props?.handleClose}
        {...props}
        className="Edit_Profile_OffCanvas"
        placement="end"
      >
        <Offcanvas.Header>
          <div className="close_btn_outer">
            <div className="img_holder">
              <img
                src="\assets\Image\offcanvas\close.png"
                className="close_img"
                onClick={() => {
                  props?.onHide();
                }}
              />
            </div>
          </div>

          <div className="title_div">
            <p className="title">Edit Profile</p>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="main_form_holder">
            <Form className="edit_p_form" onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg="6" md="6" sm="6">
                  <Form.Group className="form-group">
                    <div className="gender_div">
                      <div className="img_holder">
                        <img
                          src="\assets\Image\offcanvas\male.png"
                          className="gender_img"
                        />
                      </div>

                      <p className="text_label">Male</p>

                      <input
                        type="radio"
                        className="gender_input"
                        value="Male"
                        {...register("gender", {
                          required: "Gender is required",
                        })}
                      />
                    </div>
                  </Form.Group>
                </Col>

                <Col lg="6" md="6" sm="6">
                  <Form.Group className="form-group">
                    <div className="gender_div">
                      <div className="img_holder">
                        <img
                          src="\assets\Image\offcanvas\female.png"
                          className="gender_img"
                        />
                      </div>

                      <p className="text_label">Female</p>

                      <input
                        type="radio"
                        className="gender_input"
                        value="Female"
                        {...register("gender", {
                          required: "Gender is required",
                        })}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="form-group">
                <Form.Label>Your Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  {...register("name", {
                    required: "Name is required",
                  })}
                />
                {errors?.name && (
                  <span className="invalid-feedback d-block">
                    {errors.name.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label>Date of Birth</Form.Label>

                <InputGroup className="mb-3">
                  <Form.Control
                    ref={dateInputRef}
                    type="date"
                    name="name"
                    {...register("dob", {
                      required: "Date of Birth is required",
                    })}
                    placeholder="Date of Birth"
                    onChange={(e) => {
                      const updatedDob = e.target.value;
                      setData((prevData) => ({
                        ...prevData,
                        dob: updatedDob,
                      }));
                    }}
                    onClick={() => dateInputRef?.current?.showPicker()}
                  />
                  <InputGroup.Text id="basic-addon1">
                    {getAge(data?.dob)}
                  </InputGroup.Text>
                </InputGroup>

                {errors?.dob && (
                  <span className="invalid-feedback d-block">
                    {errors.dob.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label>Mobile Number</Form.Label>

                <Controller
                  name="contact_no"
                  control={control}
                  country={"in"}
                  rules={{
                    required: "Field is required",
                    pattern: {
                      value: /^\+?\d{1,4}[-\s]?\d{10}$/,
                      message:
                        "Invalid number format. Please enter a valid number with an optional country code",
                    },
                  }}
                  render={({ field }) => (
                    <PhoneInput
                      country={"in"}
                      {...field}
                      onChange={(value) => field.onChange(value)}
                      type="text"
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                    />
                  )}
                />
                {errors?.contact_no && (
                  <sup className="text-danger">
                    {errors?.contact_no?.message}
                  </sup>
                )}
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label>Do you smoke or chew tobacco?</Form.Label>

                <Row>
                  <Col lg="6" md="6" sm="6">
                    <Form.Group className="form-group">
                      <button
                        type="button"
                        className={`yes_no_btn ${active === 1 ? "active" : ""}`}
                        // {...register("smoke_status", {
                        //     required: "smoke_status is required",
                        //   })}

                        onClick={() => {
                          setActive(1);
                        }}
                      >
                        Yes
                      </button>
                    </Form.Group>
                  </Col>

                  <Col lg="6" md="6" sm="6">
                    <button
                      type="button"
                      className={`yes_no_btn ${active === 0 ? "active" : ""}`}
                      //   {...register("smoke_status", {
                      //     required: "smoke_status is required",
                      //   })}
                      onClick={() => {
                        setActive(0);
                      }}
                    >
                      No
                    </button>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group controlId="formFirstName" className="form-group">
                <Form.Label>Annual Income</Form.Label>
                {/* <Controller
                  name="city_id" // name of the field
                  {...register("city_id", {
                    required: "Select City",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.city_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                    />
                  )}
                /> */}

                <Form.Control
                  type="text"
                  name="income"
                  placeholder="Your Name"
                  {...register("income", {
                    required: "Income is required",
                  })}
                />

                {errors.income && (
                  <span className="text-danger">{errors.income.message}</span>
                )}
              </Form.Group>

              <Form.Group controlId="formFirstName" className="form-group">
                <Form.Label>Educational Qualification</Form.Label>
                <Controller
                  name="qualification" // name of the field
                  {...register("qualification", {
                    required: "Select qualification",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={option}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.qualification
                            ? "red"
                            : baseStyles,
                        }),
                      }}
                      {...field}
                    />
                  )}
                />

                {errors.qualification && (
                  <span className="text-danger">
                    {errors.qualification.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label>Occupation Type</Form.Label>

                <Row>
                  <Col lg="6" md="6" sm="6">
                    <Form.Group className="form-group">
                      <button
                        type="button"
                        className={`yes_no_btn ${
                          activeOccupation === "Salaried" ? "active" : ""
                        }`}
                        // {...register("occupation", {
                        //   required: "Occupation is required",
                        // })}
                        onClick={() => {
                          setActiveOccupation("Salaried");
                        }}
                      >
                        Salaried
                      </button>
                    </Form.Group>
                  </Col>

                  <Col lg="6" md="6" sm="6">
                    <Form.Group className="form-group">
                      <button
                        type="button"
                        className={`yes_no_btn ${
                          activeOccupation === "Self Employeed" ? "active" : ""
                        }`}
                        // {...register("occupation", {
                        //   required: "Occupation is required",
                        // })}
                        onClick={() => {
                          setActiveOccupation("Self Employeed");
                        }}
                      >
                        Self Employeed
                      </button>
                    </Form.Group>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label>Your City</Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  placeholder="Enter City"
                  {...register("city", {
                    required: "City is required",
                  })}
                />
                {errors?.city && (
                  <span className="invalid-feedback d-block">
                    {errors.city.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label>Pincode</Form.Label>
                <Form.Control
                  type="text"
                  name="pincode"
                  placeholder="Enter Pincode"
                  {...register("pincode", {
                    // required: "Pincode is required",
                  })}
                />
                {errors?.pincode && (
                  <span className="invalid-feedback d-block">
                    {errors.pincode.message}
                  </span>
                )}
              </Form.Group>

              <div className="btn_holder">
                <RedRoundBtn
                  btn_name="Save"
                  type="submit"
                  // onClick={() => {
                  //     props?.onHide();
                  //     setShowModal(true)
                  // }}
                />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <You_Are_Almost_There_Modal
        text="User details updated successfully."
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default Edit_Profile_OffCanvas;
